import { isString, isNumber } from 'lodash-es';

export {
    isNumber,
    isString,
    isArray,
    isPlainObject as isObject,
} from 'lodash-es';

export const isStringNumber = (value: unknown) => {
    if (!isString(value)) return false;

    return !Number.isNaN(Number(value));
};

export const toNumber = (value: unknown) => {
    if (isNumber(value)) return value;
    if (isStringNumber(value)) return Number(value);

    return 0;
};
